import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '#environments';
import { ProjectCostCode, LinkCostCodeToProject } from '#models';
import { UserSessionService } from './user-session.service';

@Injectable({ providedIn: 'root' })
export class ProjectCostCodeService {
    private _http = inject(HttpClient);
    private _userSession = inject(UserSessionService);
    private _base = `${environment.apiBaseUrl}/v1/projects`;

    getCostCodes(projectId: string): Observable<ProjectCostCode[]> {
        return this._http.get<ProjectCostCode[]>(`${this._base}/${projectId}/cost-codes`);
    }

    linkCostCode(dto: LinkCostCodeToProject): Observable<ProjectCostCode> {
        const user = this._userSession.currentUser();
        return this._http.post<ProjectCostCode>(`${this._base}/${dto.projectId}/cost-codes`, {
            costCodeId: dto.costCodeId,
            cvxPurchasingDocument: dto.cvxPurchasingDocument ?? null,
            linkedBy: user?.displayName ?? user?.email ?? 'unknown',
        });
    }

    unlinkCostCode(projectId: string, projectCostCodeId: string): Observable<void> {
        return this._http.delete<void>(`${this._base}/${projectId}/cost-codes/${projectCostCodeId}`);
    }
}
